import * as React from 'react';
import * as _ from 'lodash';
import { Redirect, useParams, useLocation } from 'react-router-dom';
import {
  Logging,
  Notification,
  Customer,
  CustomerStatus,
  ContentLoading,
  getUuidV4,
} from '@vcd-ecm-ui/Common';
import CustomerInfoProps from './CustomerInfoProps.interface';
import '../customer-info.scss';
import useCustomer from './useCustomer';
import CustomerView from '../View/CustomerView/CustomerView';
import CustomerAddEdit from '../AddEdit/CustomerAddEdit/CustomerAddEdit';

interface ParamTypes {
  uuid: string,
  tab: string,
}

const CustomerInfo = ({ gatewayEndPoint }: CustomerInfoProps): JSX.Element => {
  const { uuid, tab } = useParams<ParamTypes>();
  const [reloadKey, setReloadKey] = React.useState(getUuidV4());
  const [redirect, setRedirect] = React.useState(null);
  const [selectedTab, setSelectedTab] = React.useState(tab != null ? tab : '1');

  const location = useLocation();

  // Create a New Customer
  const createNewCustomer = (): Customer => {
    const newCustomer: Customer = {
      status: CustomerStatus.Approved,
      code: null,
      syncId: null,
      uuid: null,
      effectiveDate: null,
      endDate: null,
      createdDateTime: null,
      lastUpdatedDateTime: null,
      customField1: null,
      customField2: null,
      customField3: null,
      customField4: null,
      customField5: null,
      customField6: null,
      customField7: null,
      customField8: null,
      customField9: null,
      customField10: null,
      taxpayerDefinition: null,
      parent: null,
      name: null,
      contacts: null,
      deletedInd: false,
      exemptInd: false,
      source: null,
      excludeFromSync: false,
    };

    return newCustomer;
  };

  // Load the Customer if the UUID is specified (View / Edit), otherwise create a New Customer
  const [customer, customerNotification] = uuid ? useCustomer(gatewayEndPoint, uuid, reloadKey) : [createNewCustomer(), null];

  // Error has Occured
  const onCloseCustomerInfo = (): void => {
    // Direct back to Customers
    setRedirect('/customers');
  };

  // Refresh the Customer
  const refreshCustomer = (currentTab: string): void => {
    setSelectedTab(currentTab);

    // Force a Reload
    setReloadKey(getUuidV4());
  };

  if (redirect) {
    return (
      <Redirect to={redirect} />
    );
  }

  // Error has occured, show it
  if (customerNotification) {
    return (
      <Notification
        data={customerNotification}
        onNotificationClose={onCloseCustomerInfo}
        autoClose
      />
    );
  }

  // Valid Customer - Still busy loading
  if (!customer) {
    return (
      <ContentLoading loadingMessage="Loading Customer ..." />
    );
  }

  Logging.Debug('Customer Info', location.pathname);

  if (location.pathname.toLowerCase().startsWith('/customer/view')) {
    // View Customer
    Logging.Info('Customer View', uuid, customer);

    return (
      <CustomerView
        gatewayEndPoint={gatewayEndPoint}
        customer={customer}
        uuid={uuid}
        initialSelectedTab={selectedTab}
        refreshCustomer={refreshCustomer}
      />
    );
  // eslint-disable-next-line no-else-return
  } else if (location.pathname.toLowerCase().startsWith('/customer/add')
    || location.pathname.toLowerCase().startsWith('/customer/edit')) {
    // Add / Edit Customer
    Logging.Info('Customer Add/Edit', uuid, customer);

    return (
      <CustomerAddEdit gatewayEndPoint={gatewayEndPoint} customer={customer} uuid={uuid} />
    );
  }

  return (
    <div>
      UNKNOWN CUSTOMER ROUTE : {location.pathname}
    </div>
  );
};

export default CustomerInfo;
